import React, { useState, useEffect, useRef } from 'react'
import * as carouselStyles from '../../styles/project-modules/bills/carousel.module.less'
import Card from './Card'

/**
 * A carousel wrapper we can use to wrap cards throughout the project
 **/

function TabCarousel({ YEAR, MARKET_KEY, publicationName, cards, embed=false, embed_heading, embed_deck, url_append}) {
  // cards = data; // for some reason it uses outdated data if it is assigned in the table def instead

  let scrollRef = useRef(null)
  let activeRef = useRef(null)

  //create refs for each link in the nav for scroll purposes
  let [ticking, setTicking] = useState(false)
  let [scrollRightVisible, setscrollRightVisible] = useState(true)
  let [scrollLeftVisible, setscrollLeftVisible] = useState(false)

  function scrollCarousel(el, direction) {
    //calculate scroll positions and width so that
    //we can jump forward by roughly one photo
    let scrollWidth = el.scrollWidth
    // let clientWidth = el.clientWidth
    let photoWidth = scrollWidth / cards.length

    if (direction === 'forward') {
      el.scrollLeft += photoWidth
    } else {
      el.scrollLeft -= photoWidth
    }
  }

  //if we have a width ready for our scroller nav, set it now
  useEffect(() => {
    const initialScrollEl = scrollRef.current || null

    if (initialScrollEl) {
      const activeEl = activeRef.current

      handleScroll(initialScrollEl, activeEl)

      //add event listener to scrolling
      initialScrollEl.addEventListener('scroll', (e) => onScrollCarousel(e))
      window.addEventListener('resize', () => handleScroll(initialScrollEl))
    }

    function handleScroll(el) {
      //calculate scroll positions and width so that
      //the overlay can remove when we're at the end
      let scrollWidth = el.scrollWidth - 20
      let clientWidth = el.clientWidth
      let scrollLeft = el.scrollLeft

      if (scrollWidth - scrollLeft <= clientWidth) {
        setscrollRightVisible(false)
      } else {
        setscrollRightVisible(true)
      }

      if (scrollLeft > 10) {
        setscrollLeftVisible(true)
      } else {
        setscrollLeftVisible(false)
      }
    }

    function onScrollCarousel(e) {
      if (!ticking) {
        window.requestAnimationFrame((d) => handleScroll(e.target))
      }

      setTicking(true)
    }

    return () => {
      if (initialScrollEl) {
        initialScrollEl.removeEventListener('scroll', (e) =>
          onScrollCarousel(e)
        )
        window.removeEventListener('resize', () =>
          handleScroll(initialScrollEl)
        )
      }
    }
  }, [scrollRef, ticking])

  return (
    <div className={carouselStyles.container}>
      {embed && <h3 className={carouselStyles.carouselTitle}>{embed_heading}</h3>}
      {embed && embed_deck && <h4 className={carouselStyles.carouselDeck}>{embed_deck}</h4>}
      {embed && <base target='_parent' />}
      <div className={carouselStyles.scrollContainer} ref={scrollRef}>
        <ol
          className={carouselStyles.carousel}
          role="region"
          aria-label="link-list"
        >
          {cards.map((card) => (
              <Card
                bill={card}
                className={carouselStyles.carouselItem}
                YEAR={YEAR}
                publicationName={publicationName}
                MARKET_KEY={MARKET_KEY}
                embed={embed}
                url_append={url_append}
              />
          ))}
        </ol>
        <ul
          aria-label="navigation controls"
          className={carouselStyles.buttonContainer}
        >
          <li>
          <button
            aria-label="Previous"
            className={carouselStyles.overlayLeft}
            onClick={() => {
              scrollCarousel(scrollRef.current, 'back')
            }}
            disabled={!scrollLeftVisible}
          >
            <span>►</span>
          </button>
          </li>
          <li>
          <button
            aria-label="Next"
            className={carouselStyles.overlay}
            onClick={() => {
              scrollCarousel(scrollRef.current, 'forward')
            }}
            disabled={!scrollRightVisible}
          >
            <span>►</span>
          </button>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default TabCarousel
